import { getEdge } from "assets/js/scenes/automations/containers/editor/utils/utils";

const addHelperTrigger = (nextSubAutomation) => {
	const id = `helper_${+new Date()}`;
	const triggerEvent = {
		id: id,
		type: "editorNode",
		data: {
			baseId: "helperTrigger",
			id: id,
			initialElement: true,
			type: "helperTrigger",
		},
		position: {
			x: 750,
			y: 0,
		},
	};
	const firstTargetId = nextSubAutomation.id;
	const links = getEdge("branchingEdge", triggerEvent.id, firstTargetId);

	return {
		events: [triggerEvent],
		links: [links],
	};
};
export { addHelperTrigger };
